module.exports = __webpack_public_path__ + "img/74fbb8c.webp";